document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-kc-menu]').forEach((button) => {
    button.addEventListener('click', () => {
      const header = button.closest('.kc-header');
      const open = header.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
    });
  });

  const refreshCartCount = () => {
    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => document.querySelectorAll('[data-header-cart-count]').forEach((count) => { count.textContent = cart.item_count; }))
      .catch(() => {});
  };
  ['cart:updated', 'cart:refresh', 'ajaxProduct:added'].forEach((eventName) => document.addEventListener(eventName, refreshCartCount));
  document.addEventListener('submit', (event) => {
    if (event.target.matches('form[action*="/cart/add"]')) window.setTimeout(refreshCartCount, 900);
  });

  document.querySelectorAll('[data-kc-products]').forEach((section) => {
    const tabs = section.querySelectorAll('[data-kc-tab]');
    const panels = section.querySelectorAll('[data-kc-panel]');
    const cleanMoney = (value) => {
      const wrapper = document.createElement('span');
      wrapper.innerHTML = value || '';
      return wrapper.textContent || wrapper.innerText || value || '';
    };
    const updateSwatchNav = (swatches) => {
      const viewport = swatches.querySelector('[data-kc-swatches-viewport]');
      const prev = swatches.querySelector('[data-kc-swatch-prev]');
      const next = swatches.querySelector('[data-kc-swatch-next]');
      if (!viewport || !prev || !next) return;
      const canScroll = viewport.scrollWidth > viewport.clientWidth + 1;
      prev.disabled = !canScroll || viewport.scrollLeft <= 1;
      next.disabled = !canScroll || viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 1;
    };
    const setupSwatchNav = (swatches) => {
      const viewport = swatches.querySelector('[data-kc-swatches-viewport]');
      const prev = swatches.querySelector('[data-kc-swatch-prev]');
      const next = swatches.querySelector('[data-kc-swatch-next]');
      const firstSwatch = swatches.querySelector('[data-kc-swatch]');
      if (!viewport || !prev || !next || !firstSwatch) return;
      const getStep = () => {
        const track = swatches.querySelector('[data-kc-swatches-track]');
        const gap = track ? parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || 0) : 0;
        return firstSwatch.offsetWidth + (Number.isFinite(gap) ? gap : 7);
      };
      prev.addEventListener('click', () => {
        viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
        window.setTimeout(() => updateSwatchNav(swatches), 260);
      });
      next.addEventListener('click', () => {
        viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
        window.setTimeout(() => updateSwatchNav(swatches), 260);
      });
      viewport.addEventListener('scroll', () => updateSwatchNav(swatches), { passive: true });
      window.setTimeout(() => updateSwatchNav(swatches), 60);
    };

    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((item) => { item.classList.remove('is-active'); item.setAttribute('aria-selected', 'false'); });
      panels.forEach((panel) => panel.classList.remove('is-active'));
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      section.querySelector(`[data-kc-panel="${tab.dataset.kcTab}"]`)?.classList.add('is-active');
      window.setTimeout(() => section.querySelectorAll('[data-kc-swatches]').forEach(updateSwatchNav), 80);
    }));

    section.querySelectorAll('[data-kc-swatches]').forEach(setupSwatchNav);
    window.addEventListener('resize', () => section.querySelectorAll('[data-kc-swatches]').forEach(updateSwatchNav), { passive: true });
    section.querySelectorAll('[data-kc-swatch]').forEach((swatch) => swatch.addEventListener('click', () => {
      const card = swatch.closest('.kc-product-card');
      // The viewport is horizontally scrollable, so focusing the clicked button
      // makes the browser auto-scroll (centre) it into view. Freeze the scroll
      // position across the focus so the row stays exactly where it is.
      const vp = swatch.closest('[data-kc-swatches-viewport]');
      const keepLeft = vp ? vp.scrollLeft : 0;
      if (vp) {
        requestAnimationFrame(() => { vp.scrollLeft = keepLeft; });
      }
      card.querySelectorAll('[data-kc-swatch]').forEach((item) => item.classList.remove('is-active'));
      swatch.classList.add('is-active');
      window.setTimeout(() => {
        const swatches = swatch.closest('[data-kc-swatches]');
        if (swatches) updateSwatchNav(swatches);
      }, 260);

      const variantInput = card.querySelector('[data-kc-variant-input]');
      const label = card.querySelector('[data-kc-variant-label]');
      const image = card.querySelector('.kc-product-card__image');
      const price = card.querySelector('[data-kc-price]');
      const comparePrice = card.querySelector('[data-kc-compare-price]');
      const addButton = card.querySelector('.kc-product-card__add');

      if (variantInput) variantInput.value = swatch.dataset.variantId;
      if (label) label.textContent = swatch.dataset.label;
      if (price) price.textContent = cleanMoney(swatch.dataset.price);
      if (image && swatch.dataset.image) {
        image.removeAttribute('srcset');
        image.src = swatch.dataset.image;
      }
      if (comparePrice) {
        comparePrice.textContent = cleanMoney(swatch.dataset.comparePrice);
        comparePrice.hidden = !swatch.dataset.comparePrice;
      }
      if (addButton) {
        const available = swatch.dataset.available === 'true';
        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to Bag' : 'Sold Out';
      }
    }));
  });

  const sticky = document.querySelector('[data-kc-sticky]');
  if (sticky) {
    const toggleSticky = () => sticky.classList.toggle('is-visible', window.scrollY > 700);
    toggleSticky();
    window.addEventListener('scroll', toggleSticky, { passive: true });
  }

  const popup = document.querySelector('[data-kc-popup]');
  if (popup && popup.dataset.enabled === 'true' && !localStorage.getItem('kc_kclub_dismissed')) {
    window.setTimeout(() => popup.classList.add('is-visible'), Number(popup.dataset.delay || 2600));
  }
  document.querySelectorAll('[data-kc-popup-close]').forEach((button) => button.addEventListener('click', () => {
    popup?.classList.remove('is-visible');
    localStorage.setItem('kc_kclub_dismissed', '1');
  }));
  popup?.addEventListener('click', (event) => {
    if (event.target === popup) {
      popup.classList.remove('is-visible');
      localStorage.setItem('kc_kclub_dismissed', '1');
    }
  });
});
